import React from 'react';
import { Link } from 'gatsby';
import { Container, Row, Col } from 'react-grid-system';
import { Social } from '../header/nav/links';
import Heart from '../../../images/heart-logo.svg';
import Eqip from '../../../images/eqip-logo.png';
import Border from '../../../images/heart-beat-underline.svg';

export default function Footer() {
  return (
    <footer aria-labelledby="footerHeading">
      <Container>
        <Row className="footer-top py-32 text-center md:text-left">
          <Col lg={3} md={6} className="footer-block">
            <Link to="/">
              <img src={Heart} alt="Pace Cardiology" className="w-32" />
            </Link>
            <p>Compassionate, comprehensive & visionary cardiac care.</p>
            <div className="social-icons flex justify-between footer-icons mt-10">
              {Social.map((link, i) => (
                <a href={link.href} key={i} title={link.name}>
                  {link.icon}
                </a>
              ))}
            </div>
          </Col>
          <Col lg={3} md={6} className="footer-block">
            <h5 className="text-red-300 font-black">Barrie.</h5>
            <h6 className="text-red-300">Little Lake Health Centre</h6>
            <p>
              11 Lakeside Terrace, Unit 302
              <br />
              Barrie, ON L4M 0H9
            </p>
            <p>
              Tel: <a href="tel:7057214422">705-721-4422</a>
            </p>
            <p>
              Fax: <a href="tel:7057215577">705-721-5577</a>
            </p>
          </Col>
          <Col lg={3} md={6} className="footer-block">
            <h5 className="text-red-300 font-black">Newmarket.</h5>
            <h6 className="text-red-300">Medical Arts Building</h6>
            <p>
              581 Davis Drive, Suite 602B
              <br />
              Newmarket, ON, L3Y 2P6
            </p>
            <p>
              Tel: <a href="tel:+19059537917">905-953-7917</a>
            </p>
            <p>
              Fax: <a href="tel:9059530046">905-953-0046</a>
            </p>
          </Col>
          <Col lg={3} md={6} className="footer-block">
            <h5 className="text-red-300 font-black">Orillia.</h5>
            <h6 className="text-red-300">
              Orillia Soldiers’ Memorial Hospital
            </h6>
            <p>
              170 Colborne Street W,
              <br />
              Orillia, ON, L3V 2Z3, Room 281
            </p>
            <p>
              Tel: <a href="tel:+18886620680">888-662-0680</a>
            </p>
            <p>
              Fax: <a href="tel:18552391623">1-855-239-1623</a>
            </p>
          </Col>
        </Row>
        <img src={Border} alt="Pace Cardiology border" />
        <Row className="footer-bottom">
        <div className='flex justify-center mx-auto'>
              <img src={Eqip} alt="Echocardiography Quality Improvement Program"/>
            </div>
          <p className="flex justify-center w-full py-10 mt-0">
            &copy; 2024 PACE Cardiology. All rights reserved.
          </p>
        </Row>
      </Container>
    </footer>
  );
}
